import { defineMessages } from '@jutro/locale';

export default defineMessages({
    EnrollInEFT: {
        id: 'ml.fnol.common.views.ml-confirmation.Enroll in EFT',
        defaultMessage: 'Enroll in EFT'
    },
    Eligible: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.You may be eligible to receive your claim payment',
        defaultMessage: 'You may be eligible to receive your claim payment electonically by enrolling in EFT Payment below.'
    },
    SelfServeOptions: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-Serve-options',
        defaultMessage: 'Self-Serve Options'
    },
    Helping: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.Helping you get back on the road as soon as possible',
        defaultMessage: 'Helping you get back on the road as soon as possible'
    },
    EFTENROLLMENT: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.EFT ENROLLMENT',
        defaultMessage: 'asdfadsEFT ENROLLMENTfadsfsdaf'
    },
    Concierge: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.Choosing a Concierge...',
        defaultMessage: 'Choosing a Concierge Repair Experience ®("CARE") shop ensures peace of mind that your repairs are done right and we guarantee the repairs for as long as you own the vehicle.'
    },
    FINDCARESHOPSNEARYOU: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.FIND CARE SHOPS NEAR YOU',
        defaultMessage: 'FIND CARE SHOPS NEAR YOU'
    },
    YourEmailAddress: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.Your Email Address',
        defaultMessage: 'Your Email Address'
    },
    EMAILMETHELINK: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.EMAIL ME THE LINK',
        defaultMessage: 'EMAIL ME THE LINK'
    },
    OR: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.OR',
        defaultMessage: 'OR'
    },
    YourCellPhoneNumber: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.Your Cell Phone Number',
        defaultMessage: 'Your Cell Phone Number'
    },
    TEXTMETHELINK: {
        id: 'ml.claim.views.ml-claim-details-self-serve.self-serve-options.TEXT ME THE LINK',
        defaultMessage: 'TEXT ME THE LINK'
    },
    loading: {
        id: 'claim.controllers.MLClaimDetailsSelfServe.Loading...',
        defaultMessage: 'Loading...'
    },
    RequestingService: {
        id: 'claim.controllers.MLClaimDetailsSelfServe.Requesting service...',
        defaultMessage: 'Requesting service...'
    },
    ServiceRequest: {
        id: 'ml.claim.controllers.MLClaimDetailsSelfServe.confirm.Confirm Title',
        defaultMessage: 'Service request'
    },
    ServiceRequestCreated: {
        id: 'ml.claim.controllers.MLClaimDetailsSelfServe.confirm.Confirm Message',
        defaultMessage: 'Service Request Created Successfully'
    },
    ErrorRequestingService: {
        id: 'ml.claim.controllers.MLClaimDetailsSelfServe.link.click.error',
        defaultMessage: 'Error requesting service'
    },
    UnableToBookAppointment: {
        id: 'ml.claim.controllers.MLClaimSelfServeCareShops.bookAppointment.error',
        defaultMessage: 'Unable to book appointment at this time. Your claim consultant will help you schedule the appointment.'
    }
});